import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "AreaInvestigacionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "AreaInvestigacionPage",
            ss: ss,
            ajax: {
                "url": ss.indexAreaInvestigacion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'AreaInvestigacion', name: 'AreaInvestigacion', title: 'Área de Investigación' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                { data: 'Codigo', name: 'Codigo', title: 'Código' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            areaInvestigaciones: [],
            areaInvestigacion: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newAreaInvestigacion() {
            this.areaInvestigacion = {};
            this.$refs['frm-areaInvestigacion'].show();
        },
        showAreaInvestigacion(id) {
            this.isLoading=true;
            this.ss.showAreaInvestigacion(id).then(
                (result) => {
                    let response = result.data;
                    this.areaInvestigacion = response.data;
                    this.$refs['view-areaInvestigacion'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editAreaInvestigacion() {
            this.$refs['frm-areaInvestigacion'].show();
            this.$refs['view-areaInvestigacion'].hide();
        },
        cancelAreaInvestigacion() {
            if (this.areaInvestigacion.id) {
                this.$refs['view-areaInvestigacion'].show();
            }
            this.$refs['frm-areaInvestigacion'].hide();
        },
        saveAreaInvestigacion() {
            this.ss.storeAreaInvestigacion(this.areaInvestigacion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-areaInvestigacion'].hide();
                    this.$refs['datatable-areaInvestigacion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteAreaInvestigacion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyAreaInvestigacion(this.areaInvestigacion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-areaInvestigacion'].hide();
                                this.$refs['datatable-areaInvestigacion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-AreaInvestigacion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showAreaInvestigacion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
